import { SketchPicker, BlockPicker } from "react-color";
import { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../environment";
import { toast } from "react-toastify";

function ColorPicker() {
  //creating state to store our color and also set color using onChange event for sketch picker
  const [sketchPickerColor, setSketchPickerColor] = useState({
    r: "241",
    g: "112",
    b: "19",
    a: "1",
  });
  let bearerToken = localStorage.getItem("jwt_token");
  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
    },
  };
  // destructuring rgba from state
  const { r, g, b, a } = sketchPickerColor;

  //creating state to store our color and also set color using onChange event for block picker
  const [blockPickerColor, setBlockPickerColor] = useState("#37d67a");

  const saveColor = () => {
    alert(API_BASE_URL);
    console.log(`color= rgba(${r},${g},${b},${a})`);
    let data = {
      bg_color: `rgba(${r},${g},${b},${a})`,
    };
    axios
      .post(`${API_BASE_URL}/wp-json/custom/v1/bg-color`, data, config2)
      .then((res) => {
        console.log(res);
        // setLogoUpload(logoUpload ? false : true);
        // document.getElementById("fav_file").value = "";
        toast.success("Logo updated successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div
      className=""
      // style={{ display: "flex", justifyContent: "space-around" }}
    >
      <div className="sketchpicker">
        <h6>Sketch Picker</h6>
        {/* Div to display the color  */}
        <div
          style={{
            backgroundColor: `rgba(${r},${g},${b},${a})`,
            width: 100,
            height: 50,
            border: "2px solid white",
          }}
        ></div>
        {/* Sketch Picker from react-color and handling color on onChange event */}
        <SketchPicker
          onChange={(color) => {
            setSketchPickerColor(color.rgb);
          }}
          color={sketchPickerColor}
        />
      </div>
      <div>
        <button onClick={saveColor}>Save</button>
      </div>
    </div>
  );
}

export default ColorPicker;
